import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

export const getStudentNotifications = async () => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.NOTIFICATION.GET);
  return response;
};

export const getNotificationTypes = async () => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.NOTIFICATION.GET_TYPES);
  return response;
};

// Confirmed against the shipping mobile app's API client (2026-10-22): the
// body is a single { notification_id } per call, not a batch of ids.
export const markNotificationRead = async (notificationId) => {
  const response = await studentApi.put(STUDENT_ENDPOINTS.NOTIFICATION.MARK_READ, {
    notification_id: notificationId,
  });
  return response;
};
